module.exports = __webpack_public_path__ + "media/images/icon/ico_gold-81eeb055802dd2d2553ca8066d7bba29.png";